import React, { useEffect, useState } from "react";
import BreadcrumbItem from "../../../shared/components/BreadcrumbItem";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IUser } from "../../../shared/interfaces/user/IUser";
import { WebUserService } from "./service";
import { handleError } from "../../../shared/functions/handleError";
import { usePagination } from "../../../shared/hooks/usePagination";
import OperatorUserList from "./components/List";
import { Button, Card, CardHeader, Col, Form, Row } from "react-bootstrap";
import { IPagination } from "../../../shared/interfaces/shared/IPagination";

const OperatorUsers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [users, setUsers] = React.useState<IUser[]>([]);

  const {
    pagination,
    setPagination,
    changeFilterHandler,
    handleUpdateList,
    totalPages,
    setTotalPages,
  } = usePagination({
    perPage: 10,
  });
  const [localPagination, setLocalPagination] = useState<IPagination | null>(
    null,
  );

  const changeLocalPaginationHandler = (
    name: string,
    value: string | number | boolean | number[] | null,
  ) => {
    setLocalPagination((prev) => ({ ...prev, [name]: value }) as IPagination);
  };

  useEffect(() => {
    WebUserService.getAll(pagination)
      .then((response) => {
        setUsers(response?.data);
        setTotalPages(response?.totalPages);
      })
      .catch(handleError);
  }, [pagination, setTotalPages]);

  return (
    <React.Fragment>
      <BreadcrumbItem
        mainTitle={t("user.users")}
        subTitle={t("user.users")}
        buttonTitle={t("user.addUser")}
        onCtaClick={() => navigate("/users/create")}
      />
      <Card>
        <Card.Header>
          <h5>{t("user.filterUsers")}</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={3}>
              <Form.Control
                placeholder={t("general.searchByFirstName")}
                name={"firstName"}
                value={localPagination?.firstName ?? ""}
                onChange={(e) =>
                  changeLocalPaginationHandler(e.target.name, e.target.value)
                }
                className={"w-100"}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                placeholder={t("general.searchByLastName")}
                name={"lastName"}
                value={localPagination?.lastName ?? ""}
                onChange={(e) =>
                  changeLocalPaginationHandler(e.target.name, e.target.value)
                }
              />
            </Col>
            <Col md={3}>
              <Form.Control
                placeholder={t("general.searchByEmail")}
                value={localPagination?.email}
                name={"email"}
                onChange={(e) =>
                  changeLocalPaginationHandler(e.target.name, e.target.value)
                }
              />
            </Col>
            <Col md={3}>
              <Form.Control
                placeholder={t("general.searchByPhone")}
                value={localPagination?.phoneNumber}
                name={"phoneNumber"}
                onChange={(e) =>
                  changeLocalPaginationHandler(e.target.name, e.target.value)
                }
              />
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer className={"text-end"}>
          <Button
            variant={"light"}
            onClick={() => {
              setLocalPagination(null);
              setPagination({ page: 0, size: 20 });
            }}
          >
            {t("button.reset")}
          </Button>
          <Button
            variant={"primary"}
            className={"ms-3"}
            onClick={() => {
              setPagination((prev: IPagination) => ({
                ...prev,
                ...localPagination,
              }));
            }}
          >
            {t("button.search")}
          </Button>
        </Card.Footer>
      </Card>
      <Card className="table-card">
        <CardHeader>
          <h5>{t("user.userList")}</h5>
        </CardHeader>

        <Card.Body className="pt-3">
          <OperatorUserList
            users={users}
            pagination={pagination}
            totalPages={totalPages}
            handleUpdateList={handleUpdateList}
            changeFilterHandler={changeFilterHandler}
          />
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default OperatorUsers;
